import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

/**
 * NextPay Reader — Router (Sprint 1, 2026-05-07)
 *
 * Rotas:
 *   /                  → redireciona para /biblioteca (se logado) ou /login
 *   /login             → tela de login do Student
 *   /biblioteca        → lista de ebooks que o Student tem acesso
 *   /c/:slug           → leitor PWA do ebook (manifest é injetado aqui)
 *
 * Lazy-loading de páginas para reduzir initial bundle.
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: () => {
        const auth = useAuthStore();
        return auth.isAuthenticated ? '/biblioteca' : '/login';
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login.vue'),
      meta: { public: true }
    },
    {
      path: '/esqueci-senha',
      name: 'forgot-password',
      component: () => import('@/pages/ForgotPassword.vue'),
      meta: { public: true }
    },
    {
      // QW2 — Magic link exchange (público, com tratamento próprio de erro)
      path: '/abrir',
      name: 'magic-link',
      component: () => import('@/pages/MagicLink.vue'),
      meta: { public: true }
    },
    {
      path: '/biblioteca',
      name: 'library',
      component: () => import('@/pages/Library.vue'),
      meta: { requiresAuth: true }
    },
    {
      // QW3 — Página agregada de destaques do leitor
      path: '/destaques',
      name: 'highlights',
      component: () => import('@/pages/Highlights.vue'),
      meta: { requiresAuth: true }
    },
    {
      // MP1 — Quiz player
      path: '/quiz/:id',
      name: 'quiz',
      component: () => import('@/pages/QuizPlayer.vue'),
      meta: { requiresAuth: true },
      props: true
    },
    {
      // Bloco Rewards — Bônus desbloqueáveis por produto
      path: '/recompensas/:productId',
      name: 'rewards',
      component: () => import('@/pages/Rewards.vue'),
      meta: { requiresAuth: true },
      props: true
    },
    {
      path: '/c/:slug',
      name: 'reader',
      component: () => import('@/pages/Reader.vue'),
      meta: { requiresAuth: true },
      props: true
    },
    {
      // Catch-all → redireciona para biblioteca/login
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
});

// Guard global: protege rotas que exigem auth
router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // Hidrata sessão a partir do cookie httpOnly se ainda não foi feito
  if (!auth.hydrated) {
    await auth.hydrate();
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } };
  }

  if (to.meta.public && auth.isAuthenticated && to.name === 'login') {
    return { name: 'library' };
  }
});
